import Vue from 'vue';
import http from "../request/http";
import {APP_ID} from "@/config";
import wx from 'weixin-js-sdk';

function Location() {
    this.$listeners = [];
}

Location.prototype.getLocation = function() {
    if (this.ret === 'loading') return;
    this.ret = 'loading';
    const self = this;
    this.$loadTicketConfig().then((ret) => {
        if (ret === 'success') {
            wx.ready(function (){
                wx.getLocation({
                    type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: function (res) {
                        self.ret = 'success';
                        self.$postResult(self.ret, res.longitude, res.latitude);
                    },
                    fail: function () {
                        self.ret = 'fail';
                        self.$postResult(self.ret);
                    }
                });
            });
        } else {
            this.ret = 'fail';
            self.$postResult(self.ret);
        }
    });
};

Location.prototype.$loadTicketConfig = function() {
    if (this.preUrl === window.location.href) return Promise.resolve('success');
    this.preUrl = window.location.href;
    return http.getTicketConfig({
        url: this.preUrl
    }).then(({data}) => {
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: APP_ID, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature,// 必填，签名
            jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表
        });
        return 'success';
    }).catch(() => {
        this.preUrl = undefined;
        return 'fail'
    });
};

Location.prototype.addListener = function(listener) {
    this.$listeners.push(listener);
};

Location.prototype.$postResult = function(ret, longitude, latitude) {
    this.$listeners.forEach((listener) => {
        listener(ret, longitude, latitude);
    })
};

Location.prototype.removeListener = function(listener) {
    let index = -1;
    for (let i = 0; i < this.$listeners.length; i++) {
        if (this.$listeners[i] === listener) {
            index = i;
            break;
        }
    }
    if (index >= 0) {
        this.$listeners.splice(index, 1);
    }
};

Location.install = function () {
    Vue.prototype.$loaction = new Location();
};

export default Location;